import { observer } from "mobx-react-lite";
import { Trash2, Pencil, Eye } from "lucide-react";

import { Parameter } from "@/components/ModelParameters/AdvancedParameters/ParameterControl";
import { DraftParameterProps } from "./types";
import { Button } from "@/components/ui/button";

export const ParameterPreview = observer(
  ({ parameter, onEdit, onDelete, onView, isViewing }: DraftParameterProps) => {
    return (
      <div className="group relative rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition-all hover:shadow-md">
        <div className="flex h-full flex-col justify-between gap-3">
          <div className="min-h-[60px]">
            <Parameter
              parameter={parameter}
              isDisabled={parameter.isDisabled}
              isPreview
            />
          </div>
          {!isViewing ? (
            <div className="flex justify-end gap-2 pt-1">
              <Button
                size="sm"
                variant="destructiveOutline"
                className="h-8"
                onClick={onDelete}
                type="button"
              >
                <Trash2 className="mr-1.5 h-3.5 w-3.5" /> Delete
              </Button>
              <Button
                size="sm"
                variant="outline"
                className="h-8"
                type="button"
                onClick={onEdit}
              >
                <Pencil className="mr-1.5 h-3.5 w-3.5" /> Edit
              </Button>
            </div>
          ) : (
            <div className="flex justify-end gap-2 pt-1">
              <Button
                size="sm"
                variant="outline"
                className="h-8"
                type="button"
                onClick={onView}
              >
                <Eye className="mr-1.5 h-3.5 w-3.5" /> View
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  },
);
